import { StrictMode } from 'react';
// Amplify branch-detection test marker: v2025-12-02
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App.jsx';
import About from './pages/About.jsx';
import Contact from './pages/Contact.jsx';
import Pricing from './pages/Pricing.jsx';
import SignIn from './pages/SignIn.jsx'; 
import SignUp from './pages/SignUp.jsx';
import TermsAndConditions from './pages/TermsAndConditions.jsx';
import PrivacyPolicy from './pages/PrivacyPolicy.jsx';
import UploadBOQ from './views/uploadboq/';
import UploadBOQ1 from './views/uploadboq/Uploadboq.jsx';
import Chat from './views/chat/Chat.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import AdminRoute from './components/header/AdminRoute.jsx';
import AdminView from './pages/AdminView.jsx';
import NotFound from './pages/NotFound.jsx';
import PaymentSuccess from './pages/PaymentSuccess.jsx';
import PaymentCancel from './pages/PaymentCancel.jsx';
import Team from './pages/Team.jsx';
import { AuthProvider } from './contexts/AuthContext';

import { ChakraProvider } from '@chakra-ui/react';

const root = createRoot(document.getElementById('root'));

root.render(
	<StrictMode>
		<ChakraProvider>
			<AuthProvider>
				<Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
					<Routes>
						<Route path='/' element={<App />} />
						<Route path='/signin' element={<SignIn />} />
						<Route path='/signup' element={<SignUp />} />
						<Route path='/about' element={<About />} />
						<Route path='/contact' element={<Contact />} />
						<Route path='/pricing' element={<Pricing />} />
						<Route path='/terms' element={<TermsAndConditions />} />
						<Route path='/privacy' element={<PrivacyPolicy />} />
						{/* Signed in only (no subscription check), so admins can manage their team before paying. */}
						<Route path='/team' element={<Team />} />
						<Route path='/uploadboq' element={
							<ProtectedRoute>
								<UploadBOQ />
							</ProtectedRoute>
						} />
						<Route path='/uploadboq/UploadBOQ' element={
							<ProtectedRoute>
								<UploadBOQ1 />
							</ProtectedRoute>
						} />
						<Route path='/chat' element={
							<ProtectedRoute>
								<Chat />
							</ProtectedRoute>
						} />
						<Route path='/adminview' element={
							<AdminRoute>
								<AdminView />
							</AdminRoute>
						} />
						<Route path='/payment-success' element={<PaymentSuccess />} />
						<Route path='/payment-cancel' element={<PaymentCancel />} />
						{/* Catch-all route for 404 Not Found pages */}
						<Route path='*' element={<NotFound />} />
					</Routes>
				</Router>
			</AuthProvider>
		</ChakraProvider>
	</StrictMode>
);
